module.exports = __webpack_public_path__ + "media/קלמר.0a67fcc5.mp3";